export { default } from "./InfiniteScroll.vue";
